Object.defineProperty(exports, '__esModule', { value: true });

const INFINITE_PREFIX = '$inf$';

exports.INFINITE_PREFIX = INFINITE_PREFIX;
